import { call, put, takeLatest } from "redux-saga/effects";
// Login Redux States
import { GET_ADDRESS,EDIT_ADDRESS,ADD_ADDRESS } from "./actionTypes";
import {addAddress,editAddress,getAddress} from "../../http/fundLync/entityAndAddress.helper";
import {allAddress } from "../actions";
import { decryptedValue } from "common/utility";


function* addAddresses({ payload: { address,history } }) {
  
    try {
      const user = decryptedValue(localStorage.getItem("user"));
      const responseFromAPI =  yield call(addAddress, address);
      if(responseFromAPI.code ==201 ){
        history(`/${user.roleName}/address`);
      } 
    } catch (error) {
      console.log("error", error)
    }
  }

  function* getAddresses({ payload: { address} }) {
    try {
      const responseFromAPI =  yield call(getAddress,address);
      if(responseFromAPI.code ==200 ){
          const {data} = responseFromAPI
          yield put(allAddress({data}));
      }
    } catch (error) {
      console.log("error", error)
    }
  }

  function* editAddresses({ payload: { address,history } }) {
    try {
      const responseFromAPI =  yield call(editAddress, address);
      const user = decryptedValue(localStorage.getItem("user"));
      if(responseFromAPI.code ==201 ){
        history(`/${user.roleName}/address`);
      } 
    } catch (error) {
      console.log("error", error)
    }
  }

function* addressSaga() {
    yield takeLatest(GET_ADDRESS, getAddresses);
    yield takeLatest(EDIT_ADDRESS, editAddresses);
    yield takeLatest(ADD_ADDRESS, addAddresses);
  }


export default addressSaga;
